import {reqWithToken} from './requestHelper';

export async function getCoursesOf(params){
    return (await reqWithToken('api/courses/of',{
        params
    })).data;
}

export async function getCoursesWithKey(params){
    return (await reqWithToken('api/courses/withKey',{
        params
    })).data;
}

